<template>
  <div class="showAllData">
    <div v-for='(value,key) in params' :key='key' style="overflow:hidden">
        <h3>{{$t(`header.${(key)}`)}}</h3>
        <div :class="{w_25:['personalDetails1','personalDetails2'].includes(key),w_50:['financialDetails','Experience','Acknowledgements'].includes(key)}" v-for="(oValue,oKey) in value" :key='oKey' class="section_part" v-if="(formData[oValue]||['Marketing_Email_Preference'].includes(oValue))&&!(['Email_Confirm','Birth_Date_Month','Birth_Date_Day','checkList'].includes(oValue))">
            <div v-if="oValue=='Birth_Date_Year'">
              <label>{{$t(`${key}.birthDate`)}}</label>
              <p>{{formData.Birth_Date}}</p>
            </div>
             <div class="uploadBox" v-else-if="oValue in imgObj">
                <div v-if="formData[oValue][0]" style="padding:0">
                  <label>{{$t(`${key}.fileUpload.uploadFileArr.${imgObj[oValue]}.labelTxt`)}}</label>
                  <router-link tag="a" target="_blank" :to="{name:'pdfView',query:{pdfUrl:filePath+'/?fileName='+formData[oValue][0]['url']}}" v-if="(formData[oValue][0]['url']).includes('pdf')"  class='showPdf'><img src="@/assets/images/pdf.png"></router-link>
                  <img :src="filePath+'/?fileName='+formData[oValue][0]['url']" class='showImg' v-else/>
                </div>
            </div>
            <div v-else>
              <label>{{$t(`${key}.${oValue}`)}}</label>
              <div v-if="['Emp_Status',].includes(oValue)">
                <p v-html="$t(`${key}.${modelToSelectVal[oValue]}.${specifiedObj[formData[oValue]]}`)"></p>
              </div>
              <div v-else-if="['DT_Work_Experience','DT_Qualification'].includes(oValue)">
                <p v-if="oValue=='DT_Work_Experience'" v-html="formData[oValue]=='0'?$t(`${key}.${modelToSelectVal[oValue]}.txt2`):(formData[oValue]=='1'?$t(`${key}.${modelToSelectVal[oValue]}.subTxt2`):$t(`${key}.${modelToSelectVal[oValue]}.subTxt1`))"></p>
                <p v-if="oValue=='DT_Qualification'" v-html="formData[oValue]=='0'?$t(`${key}.${modelToSelectVal[oValue]}.txt2`):(formData[oValue]=='1'?$t(`${key}.${modelToSelectVal[oValue]}.subTxt2`):$t(`${key}.${modelToSelectVal[oValue]}.subTxt1`))"></p>
              </div>
              <div v-else-if="['Derivative_Trade_over2','Derivative_Trade_over40'].includes(oValue)">
                <p v-html="formData[oValue]=='0'?$t(`${key}.${modelToSelectVal[oValue]}.a`):$t(`${key}.${modelToSelectVal[oValue]}.b`)"></p>
              </div>
              <p v-else-if="['Marketing_Email_Preference'].includes(oValue)" v-html="(formData[oValue])?$t(`${key}.${modelToSelectVal[oValue]}.Y`):$t(`${key}.${modelToSelectVal[oValue]}.N`)"></p>
              <p v-else-if="['Nationality'].includes(oValue)" v-html="$t(`personalDetails1.${modelToSelectVal[oValue]}.${formData[oValue]}`)"></p>
              <p v-else-if="oValue=='isHaveCitizen'" v-html="formData[oValue]=='Y'?$t(`${key}.${modelToSelectVal[oValue]}.Y`):$t(`${key}.${modelToSelectVal[oValue]}.N`)"></p>
              <p v-else-if="oValue=='isDualCitizenship'" v-html="formData[oValue]=='Y'?$t(`${key}.${modelToSelectVal[oValue]}.Y`):$t(`${key}.${modelToSelectVal[oValue]}.N`)"></p>
              <p v-else-if="['Dual_Nationality'].includes(oValue)" v-html="$t(`personalDetails1.${modelToSelectVal[oValue]}.${formData[oValue]}`)"></p>
              <p v-else v-html="(oValue in modelToSelectVal)?$t(`${key}.${modelToSelectVal[oValue]}.${formData[oValue]}`):formData[oValue]"></p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { URL_DOWNLOAD } from "../api/api.js";
export default {
  name: "formtable",
  props: {
    formData: Object,
    params: Object,
  },
  data() {
    return {
      filePath: URL_DOWNLOAD,
      imgObj:{
        "Doc_Front_Img":0,
        "Doc_Back_Img":1,
        "Proof_of_Address":2,
        "Proof_of_Address_2":3,
        "Other_Files":4
      },
      specifiedObj: {
        "0": "a",
        "1": "b",
        "2": "c",
        "3": "d",
        "4": "e",
        "5": "f"
      }
    };
  },
  computed: {
    modelToSelectVal() {
      // 根据field值去找对应的select的option
      return {
        Gender: "genderSelect",
        Title: "titleSelect",
        Lang: "emailLanguages",
        Gender: "genderSelect",
        Country: "countrySelect",
        MT4_Currency: "MT4CurrencySelect",
        Account_Type: "Account_TypeSelect",
        Nationality: "countrySelect",
        isHavePass: "PotSelect",
        Doc_Type: "idTypeSelect",
        Bank: "bankSelect",
        Emp_Status: "employmentStatusSelect",
        Freelance_OwnACompany: "Freelance_OwnACompany_select",
        Industry_Sector: "Industry_Sector_select",
        Position: "FD_Position_select",
        Biz_Nature: "Industry_Sector_select",
        Annual_Income: "annualIncomeSelect",
        Total_Saving_Investments: "Total_Saving_Investments_select",
        Funds_Source: "fundsSourceSelect",
        Intend_Deposit: "intendDepositSelect",
        isHaveCitizen:"DualCitizenshipSelect",
        isDualCitizenship:"DualCitizenshipSelect",
        Dual_Nationality: "countrySelect",

        Futures_Options: "Futures_Options_select",
        CFDs_Spread_Bets: "CFDs_Spread_Bets_select",
        Derivative_Trade_over2: "Derivative_Trade_over2_select",
        Derivative_Trade_over40: "Derivative_Trade_over40_select",

        DT_Work_Experience: "DT_Work_Experience_select",
        DT_Qualification: "DT_Qualification_select",
        K_Sell_Position: "K_Sell_Position_select",
        Closing_Order: "Closing_Order_select",
        K_Profit_Change: "K_Profit_Change_select",
        K_Margin: "K_Margin_select",

        Marketing_Email_Preference: "Marketing_Email_Preference_select",
        Hear_ATFX: "hearATFXSelect",
        Rec_Type: "recTypeSelect",

        Afford_To_Lose:'Afford_To_Lose_Select', //是否承担损失
        Open_Trading_Account:'Open_Trading_Account_Select',
        Average_Annual_Investment:'Average_Annual_Investment_select', //年平均投资
        Average_Leverage_Level:'Average_Leverage_Level_select', //平均杠杆
      };
    }
  }
};
</script>

<style lang="scss" type="text/scss" scoped>
.mobileType {
  .showAllData{
    
  }
}
.pcType {
  .showAllData {
    .section_part{
      float: left;
      &.w_25{width:25%;}
      &.w_50{width:50%;}
    }
  }
}
.showAllData {
  .section_part {
    width: 100%;
    margin-bottom: 20px;
    overflow: hidden;
    & > div {
      margin-bottom: 10px;
    }
    p{
      font-weight: bold;
    }
  }
  .uploadBox {
    label {
      display: block;
      padding-bottom: 10px;
    }
    .showImg,
    .showPdf img {
      width: 100px;
      height: 80px;
    }
    .showPdf img {
      position: relative;
      top: -10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/preview.vue